import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { DocPageComponent } from '../doc-page/doc-page.component';
import { StaticContentPage } from '../../models/static-content-page.enum';

@Component({
  selector: 'cab-privacy-policy',
  standalone: true,
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DocPageComponent, TranslateModule],
})
export class PrivacyPolicyComponent {
  StaticContentPage = StaticContentPage;
}
